import { CheckCircleIcon } from "lucide-react";

export default function ThankYouMsg() {
    return (
        <div className="rounded-lg border border-green-200 bg-green-50 p-4">
            <div className="flex items-start gap-3">
                <CheckCircleIcon className="mt-0.5 h-5 w-5 text-green-600" />
                <div>
                    <h3 className="text-sm font-medium text-green-800">
                        Thank You for Submitting!
                    </h3>
                    <p className="mt-1 text-sm text-green-700">
                        Your information has been received successfully. We'll
                        review your submission and get back to you soon.
                    </p>
                </div>
            </div>
        </div>
    );
}
